

/**
 *
 * Newsletter Subscribe
 *
 * Handles the events for subscribing to the Iterable Newsletter
 */

const _model    = require( './utilities/_model.js' );
const $         = require( 'jQuery' );
const _Forms    = require( './utilities/_form-controller' );


var NewsletterSub = function(el){

    //setup some variables
    this.$el                = $(el);
    this.$form              = this.$el.find( '.itbl-c-form-newsletter-subscribe' );
    this.$subscribeSuccess  = this.$el.find( '.itbl-subscribe__success' );
    this.$confirmationWrap  = this.$el.find( '#itbl-b-confirmation__resources' );
    this.$successContent    = this.$el.find( '.itbl-newsletter-subscribe__success-content' );
    this.$confirmationSvg   = this.$el.find( '.itbl-b-confirmation__svg' );
    this.$reveal            = $(document).find( '#itbl-newsletter-modal-subscribe');

    this.FormInstance       = new Foundation.Abide( this.$form );
    this.RevealInstance     = new Foundation.Reveal( this.$reveal );

    _Forms.debug( this.RevealInstance );

    this.APIState         = {
        wp_email_to     : 'forms@iterable.com',
        wp_email_message: null, //we gotta build this message body
        wp_email_subject: 'New User Subscribes to Newsletter'
    };



    this.init();
};

NewsletterSub.prototype.init = function(){

    //events
    this.$form
        .on( 'submit', _Forms.event__PreventDefault )
        .on( 'forminvalid.zf.abide', _Forms.event__PreventDefault )
        .on( 'formvalid.zf.abide', this.event__validForm.bind(this) );

};

NewsletterSub.prototype.event__validForm = function( event, frm ){

    var marketoPayloadPromise;

    //disable normal submit event
    event.preventDefault();

    $(this.$form).addClass( 'itbl-u-faded' );

    _Forms.helper__addFormInputsToState( frm, this.APIState );

    _Forms.marketo__submit( this.APIState, undefined, undefined, this.$form )
    .finally(()=>{

        //shows the success message
        this.view__showSuccess();

    })
    .catch( ()=>{

        console.log( 'fail: ', marketoPayloadPromise );

        //then create the email message body
        var html =  $('<div />')
            .append([
                $('<p />').text( `We had some issues subscribing ${this.APIState.Email} to the Iterable newsletter` ),

            ]);

        //we have to convert this to a string
        this.APIState.wp_email_message  = html.prop( 'outerHTML' );
        //change email to mine
        this.APIState.wp_email_to       =  'gabriel.ortiz@iterable.com';
        this.APIState.wp_email_subject  = 'Newsletter Subscription Error';

    });

    //just to be sure
    return false;
};

NewsletterSub.prototype.view__showSuccess = function(){

    var success = new TimelineMax()
        .set( this.$subscribeSuccess, {className:"+=animated"} )
        .set( this.$subscribeSuccess, {className: "+=flipInX"})
        .set( this.$confirmationSvg, {className:"-=itbl-e-hide"}, "+=1")
        .set( this.$confirmationSvg, {className:"+=animated"} )
        .set( this.$confirmationSvg, {className: "+=heartBeat"} );


};


$(document).ready(function(){
    $('#itbl-newsletter-modal-subscribe').each(function(){
        new NewsletterSub(this);
    });

});
